export default __webpack_public_path__ + "static/media/img-09.1ce5d3d3.jpg";